var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 7.25999C12.5387 6.57926 13.0983 5.89854 13.7479 5.32095C14.3974 4.74337 15.1469 4.28955 15.9864 4.09359C17.3854 3.77385 18.9044 4.28955 19.8637 5.39315C20.7332 6.40392 21.0529 7.786 20.993 9.11651C20.7931 13.4174 12.3588 20.2144 12.0091 20.5032C11.6493 20.2247 3.215 13.4174 3.00514 9.11651C2.95517 7.79631 3.26496 6.40392 4.13438 5.39315C5.09373 4.29987 6.6127 3.77385 8.01176 4.09359C8.84119 4.28955 9.60068 4.75368 10.2502 5.32095C10.8998 5.88822 11.4594 6.57926 11.9991 7.25999Z",
    fill: "transparent",
    stroke: "#141414",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.fe519fc27ec97760733b337c6990bb60.svg";
export { ForwardRef as ReactComponent };